import { Module } from "wrapper6";

var $ = jQuery;

export default class Catch extends Module {

    ready(app) {

        // CATCH
        initCatch();

        $(document).on('click', '#open-catch', function(){
            showCatch();
        });

        $(document).on('click', '#close-catch', function(){
            hideCatch();
        });

        $(document).on('click', '#catch-overlay', function(){
            hideCatch();
        });

        function initCatch(){
            if ( $( "#catch" ).length ) {
                var delayTimer = parseInt($('#catch').attr('data-delay'));
                if(localStorage.getItem('catch')){
                    var object = JSON.parse(localStorage.getItem("catch")),
                        dateString = object.timestamp,
                        now = new Date().getTime().toString();
                    if((now - dateString) / 1000 / 60 / 60 > 24){
                        localStorage.removeItem('catch');
                        setTimeout( function(){ 
                            showCatch();
                        }, delayTimer );
                    }else {
                        return;
                    }
                }else {
                    setTimeout( function(){ 
                        showCatch();
                    }, delayTimer );
                }
            }
        }

        function showCatch(){
            $('body').addClass('open-catch');

            if(!localStorage.getItem('catch')){
                var object = {value: "value", timestamp: new Date().getTime()}
                localStorage.setItem('catch', JSON.stringify(object));
            }
        }

        function hideCatch(){
            $('body').removeClass('open-catch');

            if(!localStorage.getItem('catch')){
                var object = {value: "value", timestamp: new Date().getTime()}
                localStorage.setItem('catch', JSON.stringify(object));
            }
        }

    }
}


// WEBPACK FOOTER //
// ./resources/js/modules/_catch.js